<form [formGroup]="form" (ngSubmit)="accept()" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Detalle Usuario</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">

            <div class="form-group col-md-12">
                <label for="rol">Rol</label>
                <select class="form-control" id="rol" formControlName="rol"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.rol.errors }">
                    <div *ngIf="submitted && form.controls.rol.errors" class="invalid-feedback">
                        <div *ngIf="form.controls.rol.errors.required">Campo requerido</div>
                    </div>
                    <option *ngFor="let item of comboRoles" [ngValue]="item">{{item.nombre}}</option>
                </select>
            </div>

            <div class="form-group col-md-12">
                <label for="correo">Correo Electrónico</label>
                <input type="email" class="form-control" id="correo" formControlName="correo"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.correo.errors }">
                <div *ngIf="submitted && form.controls.correo.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.correo.errors.required">Campo requerido</div>
                    <div *ngIf="form.controls.correo.errors.email">Correo inválido</div>
                </div>
            </div>
        </div>

        <div class="modal-footer full-width col-md-12">
            <div class="col-md-12 text-center">
                <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                    <i class="fa fa-times-circle"></i>
                    Cancelar
                </button>
                <button type="submit" class="btn btn-success btn-fidelis col-md-4">
                    <i class="fa fa-check-circle"></i>
                    Aceptar
                </button>
            </div>
        </div>

    </div>
</form>